import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SecurityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"security"}/>
}
